import {
  PrimaryOrderStatusType,
  ApprovalStatusType,
  SalesOrderFulfillmentStatusType,
} from "../types/common/statusTypes";
import {
  WorkOrderPartStatusType,
  WorkOrderBuildStatusType,
} from "../types/workOrderTypes";
import { PurchaseOrderReceiptStatusType } from "../types/purchOrderTypes";

import theme from "../styles/theme";

const statusUtils = {
  getPrimaryOrderStatusColor: (status: PrimaryOrderStatusType) => {
    switch (status) {
      case "DRAFT":
        return "primdraft";
      case "REJECTED":
        return "primrejected";
      case "PROCESSING":
        return "primprocessing";
      case "COMPLETE":
        return "primcomplete";
      case "VOID":
        return "primvoid";
    }
  },
  getApprovalStatusColor: (status: ApprovalStatusType) => {
    switch (status) {
      case "APPROVED":
        return "appapproved";
      case "PENDING":
        return "apppending";
      case "REJECTED":
        return "apprejected";
      case "VOID":
        return "appvoid";
    }
  },
  getSoFulfillmentStatusColor: (status: SalesOrderFulfillmentStatusType) => {
    switch (status) {
      case "APPROVAL":
        return "fillapproval";
      case "REJECTED":
        return "fillrejected";
      case "FULFILL":
        return "fillfulfill";
      case "PARTIAL":
        return "fillpartial";
      case "FULL":
        return "fillfull";
      case "COMPLETE":
        return "fillcomplete";
      case "VOID":
        return "fillvoid";
    }
  },
  getPoReceiptStatusColor: (status: PurchaseOrderReceiptStatusType) => {
    switch (status) {
      case "APPROVAL":
        return "recapproval";
      case "REJECTED":
        return "recrejected";
      case "RECEIPT":
        return "recreceipt";
      case "PARTIAL":
        return "recpartial";
      case "FULL":
        return "recfull";
      case "COMPLETE":
        return "reccomplete";
      case "VOID":
        return "recvoid";
    }
  },
  getWoBuildStatusColor: (status: WorkOrderBuildStatusType) => {
    switch (status) {
      case "REJECTED":
        return "buildrejected";
      case "COMPLETE":
        return "buildcomplete";
      case "VOID":
        return "buildvoid";
      case "APPROVAL":
        return "buildapproval";
      case "READY":
        return "buildready";
      case "IN_PROCESS":
        return "buildprocess";
    }
  },
  getWoPartStatusColor: (status: WorkOrderPartStatusType) => {
    switch (status) {
      case "PENDING":
        return "partpending";
      case "PARTIAL":
        return "partpartial";
      case "COMPLETE":
        return "partcomplete";
      case "VOID":
        return "partvoid";
    }
  },
};

export default statusUtils;
